import { createContext } from 'react';
export default createContext({
    path: [],
    detachedId: null
});
